import { PluginContainerData_Alignment, PluginContainerData_Width_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
const commonConfig = { getAudioUrl: (src) => `https://static.wixstatic.com/${src.id}` };
const DEFAULT_CONFIGS = Object.freeze({
  viewer: {
    ...commonConfig,
    size: "content",
    alignment: "center"
  },
  editor: {
    ...commonConfig
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true
  }
});
export {
  DEFAULT_CONFIGS,
  RICOS_DEFAULTS
};
//# sourceMappingURL=defaults.js.map
